import { Modal as BaseModal, ModalProps as BaseModalProps } from "antd"
import React from "react"
import styles from "./modal.module.scss"

export interface IModalProps extends BaseModalProps {
    children?: React.ReactNode
    className?: string
}

export const Modal: React.FC<IModalProps> = ({ children, className, ...props }) => {
    return (
        <BaseModal {...props} className={`${styles.customModal} ${className || ""}`}>
            {children}
        </BaseModal>
    )
}

export default Modal
